import React, { useState } from "react";
import axios from "axios";


const useCheckout = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const mainApi = '/koha/checkout'
    const [data, setData] = useState([])
    const [patron_data, setPatronData] = useState([])

    const getCheckoutData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/library' + mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    //新增借書
    const postCheckoutData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/library' + mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                console.log({responseData})
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error",
                            values: responseData?.message
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    //續借書
    const postCheckoutRenewData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(`/koha/checkout/renew`,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error",
                            message: responseData?.message
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }

    // const patchCheckoutData = (data) => {

    //     onBefore({
    //         axiosMode: "patch"
    //     })
    //     axios.patch(mainApi,

    //             data

    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "patch",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    // const deleteCheckoutData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete(mainApi,
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }

    const getSpecificPatronData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/library/organization_structure/api/staff/concatenation/specific_patron', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setPatronData(data?.data || [])
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }

    return {
        CheckoutData: data,
        getCheckoutData,
        postCheckoutData,
        postCheckoutRenewData,
        // patchCheckoutData,
        // deleteCheckoutData,
        CheckoutPatronData: patron_data,
        getSpecificPatronData,
    }
}
export { useCheckout }
